module.exports = __webpack_public_path__ + "img/rl_1.8220b69c.jpg";